import React from 'react';
import { Beaker, ArrowLeft, Edit, Save, X } from 'lucide-react';
import { LabSample } from '../../contexts/LabSampleContext';
import { getLabStatusColor, getLabPriorityColor } from '../../utils/labHelpers';

interface LabSampleHeaderProps {
    sample: LabSample;
    isEditing: boolean;
    setIsEditing: (value: boolean) => void;
    onSave: () => void;
    onCancel: () => void;
    onBack: () => void;
}

export const LabSampleHeader: React.FC<LabSampleHeaderProps> = ({
    sample,
    isEditing,
    setIsEditing,
    onSave,
    onCancel,
    onBack,
}) => {
    return (
        <div className="mb-6">
            <div className="flex items-center justify-between mb-4">
                <div className="flex items-center gap-4">
                    <button
                        onClick={onBack}
                        className="p-2 rounded-lg hover:bg-gray-200 transition-colors"
                    >
                        <ArrowLeft className="w-5 h-5 text-gray-600" />
                    </button>
                    <div>
                        <h1 className="text-3xl font-bold text-gray-900 flex items-center gap-3">
                            <Beaker className="w-8 h-8 text-blue-600" />
                            {sample.sampleNumber}
                        </h1>
                        <p className="text-gray-600 mt-1">{sample.product}</p>
                    </div>
                </div>
                <div className="flex items-center gap-2">
                    {isEditing ? (
                        <>
                            <button
                                onClick={onSave}
                                className="flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
                            >
                                <Save className="w-4 h-4" />
                                Save
                            </button>
                            <button
                                onClick={onCancel}
                                className="flex items-center gap-2 px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors"
                            >
                                <X className="w-4 h-4" />
                                Cancel
                            </button>
                        </>
                    ) : (
                        <button
                            onClick={() => setIsEditing(true)}
                            className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                        >
                            <Edit className="w-4 h-4" />
                            Edit
                        </button>
                    )}
                </div>
            </div>

            {/* Status Badges */}
            <div className="flex items-center gap-3">
                <span className={`px-3 py-1 rounded-full text-sm font-medium ${getLabStatusColor(sample.status)}`}>
                    {sample.status.replace('_', ' ').toUpperCase()}
                </span>
                <span className={`px-3 py-1 rounded-full text-sm font-medium border ${getLabPriorityColor(sample.priority)}`}>
                    {sample.priority.toUpperCase()} PRIORITY
                </span>
            </div>
        </div>
    );
};
